<template>
	<div class="schedule-calendar">
		<div class="calendar-day" v-if="scheduleCalendarViewMode == 'day'">
			<div class="table-head">
				<div class="table-head-broadside"></div>
				<div class="table-head-each" v-for="(item, index) in calendarDayTable" :key="index"
					:class="item.isCurrentDay?'calendar-currentDay-day':item.isExpiredDay?'calendar-expiredDay-day':''">
					<span class="table-head-each-text table-head-each-date">{{item.day}}</span>
					<span class="table-head-each-text table-head-each-weekDay">{{item.weekDay}}</span>
				</div>
			</div>
			<div class="table-body">
				<div class="table-body-broadside">
					<span>上</span>
					<span>午</span>
				</div>
				<div class="table-body-each" v-for="(item, index) in calendarDayTable" :key="index"
					v-if="item.isCurrentDay" style="background-color: #F2F8FF;">
					<div class="schedule-list">
						<div class="schedule-list-each"
							v-for="(scheduleItem, scheduleIndex) in item.scheduleList.morningList" :key="scheduleIndex"
							@click="editScheduleInfo(scheduleItem)"
							:class="scheduleItem.isExpired?'schedule-expired':scheduleItem.isCurrentDate?'schedule-current':scheduleItem.scheduleColorStyle == 1?'schedule-orange':'schedule-expired'">
							<div class="schedule-each-info">
								<span>{{scheduleItem.start_time}}</span>
								<span>{{scheduleItem.location}}</span>
							</div>
							<div class="schedule-each-title">
								<span>{{scheduleItem.content}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table-body">
				<div class="table-body-broadside" style="border-bottom: 1px solid #999999;">
					<span>下</span>
					<span>午</span>
				</div>
				<div class="table-body-each" v-for="(item, index) in calendarDayTable" :key="index"
					v-if="item.isCurrentDay">
					<div class="schedule-list" v-for="(scheduleItem, scheduleIndex) in item.scheduleList.afternoonList"
						:key="scheduleIndex">
						<div class="schedule-list-each" @click="editScheduleInfo(scheduleItem)"
							:class="scheduleItem.isExpired?'schedule-expired':scheduleItem.isCurrentDate?'schedule-current':scheduleItem.scheduleColorStyle == 1?'schedule-orange':'schedule-expired'">
							<div class="schedule-each-info">
								<span>{{scheduleItem.start_time}}</span>
								<span>{{scheduleItem.location}}</span>
							</div>
							<div class="schedule-each-title">
								<span>{{scheduleItem.content}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="calendar-week" v-if="scheduleCalendarViewMode == 'week'">
			<div class="table-head">
				<div class="table-head-broadside"></div>
				<div class="table-head-each" v-for="(item, index) in calendarWeekTable" :key="index"
					:class="item.isCurrentDay?'calendar-currentDay-week':item.isExpiredDay?'calendar-expiredDay-day':''">
					<span class="table-head-each-text table-head-each-date">{{item.day}}</span>
					<span class="table-head-each-text table-head-each-weekDay">{{item.weekDay}}</span>
				</div>
			</div>
			<div class="table-body">
				<div class="table-body-broadside">
					<span>上</span>
					<span>午</span>
				</div>
				<div class="table-body-each" v-for="(item, index) in calendarWeekTable" :key="index"
					style="background-color: #F2F8FF;" :class="item.isCurrentDay?'calendar-currentDay-week':''">
					<div class="schedule-list">
						<div class="schedule-list-each"
							v-for="(scheduleItem, scheduleIndex) in item.scheduleList.morningList"
							@click="editScheduleInfo(scheduleItem)"
							:class="scheduleItem.isExpired?'schedule-expired':scheduleItem.isCurrentDate?'schedule-current':scheduleItem.scheduleColorStyle == 1?'schedule-orange':'schedule-expired'">
							<div class="schedule-each-info">
								<span>{{scheduleItem.start_time}}</span>
								<span>{{scheduleItem.location}}</span>
							</div>
							<div class="schedule-each-title">
								<span>{{scheduleItem.content}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table-body">
				<div class="table-body-broadside" style="border-bottom: 1px solid #999999;">
					<span>下</span>
					<span>午</span>
				</div>
				<div class="table-body-each" v-for="(item, index) in calendarWeekTable" :key="index"
					:class="item.isCurrentDay?'calendar-currentDay-week':''">
					<div class="schedule-list" v-for="(scheduleItem, scheduleIndex) in item.scheduleList.afternoonList">
						<div class="schedule-list-each" @click="editScheduleInfo(scheduleItem)"
							:class="scheduleItem.isExpired?'schedule-expired':scheduleItem.isCurrentDate?'schedule-current':scheduleItem.scheduleColorStyle == 1?'schedule-orange':'schedule-expired'">
							<div class="schedule-each-info">
								<span>{{scheduleItem.start_time}}</span>
								<span>{{scheduleItem.location}}</span>
							</div>
							<div class="schedule-each-title">
								<span>{{scheduleItem.content}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="calendar-month" v-if="scheduleCalendarViewMode == 'month'">
			<div class="table-head">
				<div class="table-head-each" v-for="(item, index) in calendarWeekTable" :key="index">
					<span class="table-head-each-text">{{item.weekDay}}</span>
				</div>
			</div>
			<div class="table-body">
				<div class="table-body-each" v-for="(item, index) in calendarMonthTable" :key="index"
					:style="item.hasLeftBorder?'border-left:1px solid #999999;':''"
					:class="!item.isCurrentMonth?'table-body-each-notCurrentMonth':''">
					<div class="table-body-each-monthDate" :class="item.isCurrentDay?'month-currentDay':''">
						<span class="table-body-each-monthDate-day">{{item.day}}</span>
						<div class="schedule-list" v-for="(scheduleItem, scheduleIndex) in item.scheduleList">
							<div class="schedule-list-each" @click="editScheduleInfo(scheduleItem)"
								:class="scheduleItem.isExpired?'schedule-expired':scheduleItem.isCurrentDate?'schedule-current':scheduleItem.scheduleColorStyle == 1?'schedule-orange':'schedule-expired'">
								<div class="schedule-each-info">
									<span>{{scheduleItem.start_time}}</span>
								</div>
								<div class="schedule-each-title">
									<div class="schedule-each-title-text">
										<span>{{scheduleItem.content}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="isShowEditSchedule" :close-on-click-modal="false">
			<div slot="title" class="dialog-title">
				<span>日程详情</span>
			</div>
			<editSchedule :memberList="memberList" :useMode="'edit'" :scheduleInfo="scheduleInfo"
				@confirmEditSchedule="confirmEditSchedule" :viewUserId="viewUserId">
			</editSchedule>
		</el-dialog>
	</div>
</template>

<script>
	import editSchedule from './EditSchedule.vue';
	export default {
		components: {
			editSchedule
		},
		props: {
			memberList: { //人员管理列表
				type: Array,
				default: []
			},
			userId: { //用户Id
				type: Number,
				default: -1
			},
			viewUserId: { //查看的用户Id
				type: Number,
				default: -1
			}
		},
		data() {
			return {
				calendarDayTable: [], //日程日历日视图表
				calendarWeekTable: [], //日程日历周视图表
				calendarMonthTable: [], //日程日历月视图表
				scheduleCalendarViewMode: 'week', //日程日历视图模式-日、周、月，默认周
				scheduleList: [], //日程数据
				isShowEditSchedule: false, //是否显示编辑日程弹窗
				scheduleInfo: '', //当前选中编辑/查看的日程信息
				loading: '', //加载中
				scheduleDate: null, //日历模式日程日期
				userInfo: '', //用户信息
				viewDate: '', //查看的日期
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				that.userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.viewDate = new Date();
			})
			that.$bus.$on('updateScheduleList', () => {
				that.updateScheduleList();
			})
			that.$bus.$on('changeScheduleView', (flag) => {
				if (flag == 0) { //日视图
					that.scheduleCalendarViewMode = "day";
				} else if (flag == 1) { //周视图
					that.scheduleCalendarViewMode = "week";
				} else if (flag == 2) { //月视图
					that.scheduleCalendarViewMode = "month";
				}
				that.updateScheduleList();
			})
			that.$bus.$on('changeCalendarDate', (flag) => {
				let dateTime;
				if (flag == 1) {
					if (that.scheduleCalendarViewMode == "day") {
						dateTime = that.viewDate.getTime() - 24 * 60 * 60 * 1000;
					} else if (that.scheduleCalendarViewMode == "week") {
						dateTime = that.viewDate.getTime() - 24 * 60 * 60 * 1000 * 7;
					} else if (that.scheduleCalendarViewMode == "month") {
						that.viewDate.setMonth(that.viewDate.getMonth() - 1);
						dateTime = that.viewDate.getTime();
					}
				} else if (flag == 2) {
					if (that.scheduleCalendarViewMode == "day") {
						dateTime = that.viewDate.getTime() + 24 * 60 * 60 * 1000;
					} else if (that.scheduleCalendarViewMode == "week") {
						dateTime = that.viewDate.getTime() + 24 * 60 * 60 * 1000 * 7;
					} else if (that.scheduleCalendarViewMode == "month") {
						that.viewDate.setMonth(that.viewDate.getMonth() + 1);
						dateTime = that.viewDate.getTime();
					}
				}
				// console.log(dateTime)
				that.viewDate = new Date(dateTime);
				that.updateScheduleList();
				that.$bus.$emit('updateTableDate', that.viewDate);
			})
		},
		watch: {
			viewUserId: {
				handler(newViewUserId, oldViewUserId) {
					let that = this;
					if (newViewUserId != -1) {
						that.updateScheduleList();
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			//更新日程列表
			updateScheduleList() {
				let that = this;
				that.loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.calendarWeekTable = that.$common.getWeekViewDateList(that.viewDate);
				that.calendarDayTable = that.$common.getWeekViewDateList(that.viewDate);
				that.calendarMonthTable = that.$common.getMonthViewDateList(that.viewDate);
				that.getSchedule();
			},
			//获取日程信息
			getSchedule() {
				let that = this;
				let params = {
					userId: that.viewUserId
				};
				if (that.userId == that.viewUserId && that.userInfo.role != 1 && that.userInfo.role != 2) {
					if (that.scheduleCalendarViewMode == "week") {
						params.startTime = new Date(that.calendarWeekTable[0].date);
						params.startTime.setHours(0, 0, 0);
						params.endTime = new Date(that.calendarWeekTable[that.calendarWeekTable.length - 1].date);
						params.endTime.setHours(23, 59, 0);
					} else if (that.scheduleCalendarViewMode == "day") {
						if (that.viewDate) {
							params.startTime = new Date(that.viewDate);
							params.endTime = new Date(that.viewDate);
						} else {
							params.startTime = new Date();
							params.endTime = new Date();
						}
						params.startTime.setHours(0, 0, 0);
						params.endTime.setHours(23, 59, 0);
					} else if (that.scheduleCalendarViewMode == "month") {
						params.startTime = new Date(that.calendarMonthTable[0].date);
						params.startTime.setHours(0, 0, 0);
						params.endTime = new Date(that.calendarMonthTable[that.calendarMonthTable.length - 1].date);
						params.endTime.setHours(23, 59, 0);
					}
					// console.log(params)
					that.$api.getScheduleSignal(params).then(res => {
						console.log(res)
						if (res.code == 1) {
							that.scheduleList = res.data;
							that.assembleSchedule();
						} else {
							that.loading.close();
						}
					}).catch(err => {
						console.log(err)
						that.loading.close();
					})
				} else {
					that.$api.getSchedule(params).then(res => {
						// console.log(res)
						if (res.code == 1) {
							that.scheduleList = res.data;
							if (that.viewUserId != 1) {
								that.getRepresentation();
							} else {
								that.assembleSchedule();
							}
						} else {
							that.loading.close();
						}
					}).catch(err => {
						console.log(err)
						that.loading.close();
					})
				}
			},
			//获取用户修改的日程
			getRepresentation() {
				let that = this;
				let params = {
					userId: that.viewUserId
				};
				that.$api.getRepresentation(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						that.scheduleList.forEach((item, index) => {
							res.data.forEach((resItem, resIndex) => {
								if (item.scheduleId == resItem.scheduleId) {
									that.scheduleList[index] = JSON.parse(resItem.content);
									that.scheduleList[index].representationId = resItem.id;
								}
							})
						})
						that.assembleSchedule();
					} else {
						that.loading.close();
					}
				}).catch(err => {
					console.log(err)
					that.loading.close();
				})
			},
			//组装日程数据
			assembleSchedule() {
				let that = this;
				let date = new Date(that.viewDate);
				that.scheduleList.forEach((item, index) => {
					item.startTime = that.$utils.fmtDate(new Date(item.startTime), "yyyy-MM-dd hh:mm");
					item.start_time = item.startTime.split(" ")[1];
					let scheduleDate = new Date(item.startTime);
					if (scheduleDate < date) {
						item.isExpired = true;
					} else {
						item.isExpired = false;
					}
					if (that.$utils.fmtDate(scheduleDate, 'yyyy-MM-dd') == that.$utils.fmtDate(date,
							'yyyy-MM-dd')) {
						item.isCurrentDate = true;
					} else {
						item.isCurrentDate = false;
					}
					item.scheduleColorStyle = 1;
				});
				that.calendarWeekTable.forEach((item, index) => {
					if (item.date == that.$utils.fmtDate(date, "yyyy-MM-dd")) {
						item.isCurrentDay = true;
					} else if (item.date < that.$utils.fmtDate(date, "yyyy-MM-dd")) {
						item.isExpiredDay = true;
					}
					that.scheduleList.forEach((scheduleItem, scheduleIndex) => {
						if (item.date == scheduleItem.startTime.split(" ")[0]) {
							if (scheduleItem.startTime.split(" ")[1] < "12:00") {
								item.scheduleList.morningList.push(scheduleItem);
							} else {
								item.scheduleList.afternoonList.push(scheduleItem);
							}
						}
					})
				})
				// console.log(that.calendarWeekTable)
				that.calendarDayTable.forEach((item, index) => {
					if (item.date == that.$utils.fmtDate(date, "yyyy-MM-dd")) {
						item.isCurrentDay = true;
					} else if (item.date < that.$utils.fmtDate(date, "yyyy-MM-dd")) {
						item.isExpiredDay = true;
					}
					that.scheduleList.forEach((scheduleItem, scheduleIndex) => {
						if (item.date == that.$utils.fmtDate(date, "yyyy-MM-dd")) {
							if (scheduleItem.startTime.split(" ")[0] == item.date) {
								if (scheduleItem.startTime.split(" ")[1] < "12:00") {
									item.scheduleList.morningList.push(scheduleItem);
								} else {
									item.scheduleList.afternoonList.push(scheduleItem);
								}
							}
						}
					})
				})
				// console.log(that.calendarDayTable)
				that.calendarMonthTable.forEach((item, index) => {
					if (item.date == that.$utils.fmtDate(date, "yyyy-MM-dd")) {
						item.isCurrentDay = true;
					}
					that.scheduleList.forEach((scheduleItem, scheduleIndex) => {
						if (item.date == scheduleItem.startTime.split(" ")[0]) {
							item.scheduleList.push(scheduleItem);
						}
					})
				})
				// console.log(that.calendarMonthTable)
				that.$forceUpdate();
				that.loading.close();
			},
			//点击编辑日程详细信息
			editScheduleInfo(scheduleInfo) {
				let that = this;
				that.isShowEditSchedule = true;
				that.scheduleInfo = scheduleInfo;
			},
			//点击完成编辑日程
			confirmEditSchedule() {
				let that = this;
				that.updateScheduleList();
				that.isShowEditSchedule = false;
			}
		},
	}
</script>

<style lang="scss">
	.calendar-day,
	.calendar-week,
	.calendar-month {
		.calendar-currentDay-week {
			background-color: #D0DFFE !important;
		}

		.calendar-currentDay-day {
			span {
				font-weight: bold !important;
				color: #1A66FE !important;
			}
		}

		.calendar-expiredDay-day {
			span {
				font-weight: 400 !important;
				color: #999999 !important;
			}
		}

		.table-head {
			background-color: #E8EFFF;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			.table-head-broadside {
				border-top: 1px solid #999999;
				border-left: 1px solid #999999;
			}

			.table-head-each {
				height: 100%;
				border-top: 1px solid #999999;
				border-right: 1px solid #999999;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex: 1;

				.table-head-each-text {
					font-weight: 400;
					color: #666666;
				}

				.table-head-each-date {}

				.table-head-each-weekDay {}
			}
		}

		.table-body {
			display: flex;
			flex-direction: row;
			align-items: stretch;
			justify-content: flex-start;

			.table-body-broadside {
				border-left: 1px solid #999999;
				background-color: #E8EFFF;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				span {
					font-weight: 400;
					color: #333333;
				}
			}

			.table-body-each {
				min-height: calc(100% - 1px);
				border-bottom: 1px solid #999999;
				border-right: 1px solid #999999;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				flex: 1;

				.schedule-list {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;

					.schedule-list-each {
						cursor: pointer;

						.schedule-each-info {
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;

							span {
								color: #fff;
								display: flex;
								flex-direction: row;
								align-items: center;
								justify-content: center;
								width: 100%;
								box-sizing: border-box;
							}
						}

						.schedule-each-title {
							span {
								color: #fff;
							}
						}
					}

					.schedule-expired {
						.schedule-each-info {
							background-color: #A1A0A0;
						}

						.schedule-each-info span:last-child {
							background-color: #C4C2C2;
						}

						.schedule-each-title {
							background-color: #D6D3D3;
						}
					}

					.schedule-current {
						.schedule-each-info {
							background-color: #E01618;
						}

						.schedule-each-info span:last-child {
							background-color: #F15456;
						}

						.schedule-each-title {
							background-color: #FC7576;
						}
					}

					.schedule-orange {
						.schedule-each-info {
							background-color: #E19008;
						}

						.schedule-each-info span:last-child {
							background-color: #EBA839;
						}

						.schedule-each-title {
							background-color: #F0BE6A;
						}
					}

					.schedule-purple {
						.schedule-each-info {
							background-color: #6B5BF4;
						}

						.schedule-each-title {
							background-color: #A49AFA;
						}
					}

					.schedule-green {
						.schedule-each-info {
							background-color: #43B2A3;
						}

						.schedule-each-title {
							background-color: #67C9B1;
						}
					}

					.schedule-yellow {
						.schedule-each-info {
							background-color: #F7B548;
						}

						.schedule-each-title {
							background-color: #F8C268;
						}
					}

					.schedule-blue {
						.schedule-each-info {
							background-color: #299CEC;
						}

						.schedule-each-title {
							background-color: #6BBDF5;
						}
					}
				}
			}
		}
	}

	.calendar-day {
		.table-head {
			.table-head-each {
				border-right: 0;
			}

			.table-head-each:last-child {
				border-right: 1px solid #999999;
			}
		}

		.table-body {
			.table-body-each {
				border-right: 0;
				box-sizing: border-box;

				.schedule-list {
					.schedule-list-each {
						display: flex;
						flex-direction: row;

						.schedule-each-info {
							flex-direction: row;
							flex-shrink: 0;
							align-items: stretch;

							span {
								width: unset;
							}
						}

						.schedule-each-title {
							width: 100%;
						}
					}
				}
			}

			.table-body-each:last-child {
				border-right: 1px solid #999999;
			}
		}
	}

	.calendar-month {
		.table-head {
			.table-head-each {}

			.table-head-each:first-child {
				border-left: 1px solid #999999;
			}
		}

		.table-body {
			flex-wrap: wrap;

			.table-body-each {
				background-color: #F2F8FF;

				.table-body-each-monthDate {
					.table-body-each-monthDate-day {
						font-weight: 400;
						color: #333333;
						display: inline-block;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
					}
				}

				.month-currentDay {
					.table-body-each-monthDate-day {
						background-color: #1A66FE;
						border-radius: 50%;
						color: #fff;
					}
				}

				.schedule-list {
					.schedule-list-each {
						display: flex;
						flex-direction: row;

						.schedule-each-info {
							flex-direction: row;
							flex-shrink: 0;
						}

						.schedule-each-title {
							width: 100%;
							overflow-x: hidden;
							color: #fff;

							.schedule-each-title-text {
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}
					}

					.schedule-expired {
						.schedule-each-info span:last-child {
							background-color: unset;
						}
					}

					.schedule-current {
						.schedule-each-info span:last-child {
							background-color: unset;
						}
					}

					.schedule-orange {
						.schedule-each-info span:last-child {
							background-color: unset;
						}
					}
				}
			}

			.table-body-each-notCurrentMonth {
				background-color: #E8E4E4;
			}
		}
	}

	@media screen and (min-width: 1024px) {

		.calendar-day,
		.calendar-week,
		.calendar-month {
			.table-head {
				height: 62px;

				.table-head-broadside {
					width: 37px;
					height: 62px;
				}

				.table-head-each {
					min-width: 100px;

					.table-head-each-text {
						font-size: 17px;
					}

					.table-head-each-date {}

					.table-head-each-weekDay {
						margin: 4px 0 0;
					}
				}
			}

			.table-body {
				min-height: 180px;

				.table-body-broadside {
					width: 37px;

					span {
						font-size: 17px;
					}

					span:last-child {
						margin: 84px 0 0;
					}
				}

				.table-body-each {
					min-width: 108px;

					.schedule-list {
						padding: 0 0 12px;

						.schedule-list-each {
							width: calc(100% - 36px);
							margin: 12px 0 0;

							.schedule-each-info {
								border-radius: 4px 4px 0 0;

								span {
									padding: 4px 14px;
									word-break: break-all;
									font-size: 14px;
								}

								span:last-child {
									margin: 4px 0 0;
								}
							}

							.schedule-each-title {
								padding: 4px;
								line-height: 1.2;
								border-radius: 0 0 8px 8px;

								.schedule-each-title-text {
									span {
										font-size: 14px;
									}
								}
							}
						}
					}
				}
			}
		}

		.calendar-day {
			.table-body {
				.table-body-each {
					padding: 18px 0;

					.schedule-list {
						width: calc(100% - 40px);

						.schedule-list-each {
							.schedule-each-info {
								border-radius: 8px 0 0 8px;

								span:first-child {
									padding: 12px 23px;
								}

								span:last-child {
									margin: 0;
									min-width: 200px;
								}
							}

							.schedule-each-title {
								padding: 12px 23px;
								border-radius: 0 8px 8px 0;
							}
						}
					}
				}
			}
		}

		.calendar-month {
			.table-head {
				height: 36px;

				.table-head-each {
					.table-head-each-text {
						font-size: 14px;
					}
				}
			}

			.table-body {
				.table-body-each {
					min-width: calc(100%/8);
					min-height: 130px;

					.table-body-each-monthDate {
						width: calc(100% - 12px);
						padding: 4px 0 0;

						.table-body-each-monthDate-day {
							font-size: 14px;
							width: 22px;
							height: 22px;
						}
					}

					.schedule-list {
						padding: 0;

						.schedule-list-each {
							margin: 5px 0 0;
							width: calc(100% - 5px);

							.schedule-each-info {
								border-radius: 8px 0 0 8px;

								span {
									padding: 4px 6px;
								}

								span:last-child {
									margin: 0;
								}
							}

							.schedule-each-title {
								padding: 9px 14px;
								border-radius: 0 8px 8px 0;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {

		.calendar-day,
		.calendar-week,
		.calendar-month {
			.table-head {
				height: 80px;

				.table-head-broadside {
					width: 60px;
					height: 80px;
				}

				.table-head-each {
					min-width: 180px;

					.table-head-each-text {
						font-size: 27px;
					}

					.table-head-each-date {}

					.table-head-each-weekDay {
						margin: 4px 0 0;
					}
				}
			}

			.table-body {
				min-height: 300px;

				.table-body-broadside {
					width: 60px;

					span {
						font-size: 27px;
					}

					span:last-child {
						margin: 84px 0 0;
					}
				}

				.table-body-each {
					min-width: 180px;

					.schedule-list {
						padding: 0 0 12px;

						.schedule-list-each {
							width: calc(100% - 20px);
							margin: 12px 0 0;

							.schedule-each-info {
								border-radius: 8px 8px 0 0;

								span {
									padding: 4px 14px;
									font-size: 21px;
								}

								span:last-child {
									margin: 4px 0 0;
								}
							}

							.schedule-each-title {
								padding: 10px 14px;
								line-height: 1.2;
								border-radius: 0 0 8px 8px;

								span {
									font-size: 18px;
								}
							}
						}
					}
				}
			}
		}

		.calendar-day {
			.table-body {
				.table-body-each {
					padding: 30px 0;

					.schedule-list {
						width: calc(100% - 40px);

						.schedule-list-each {
							.schedule-each-info {
								border-radius: 8px 0 0 8px;

								span:first-child {
									padding: 20px 40px;
								}

								span:last-child {
									margin: 0;
									min-width: 300px;
								}
							}

							.schedule-each-title {
								padding: 20px 40px;
								border-radius: 0 8px 8px 0;
							}
						}
					}
				}
			}
		}

		.calendar-month {
			.table-head {
				height: 60px;

				.table-head-each {
					.table-head-each-text {
						font-size: 21px;
					}
				}
			}

			.table-body {
				.table-body-each {
					min-width: calc(100%/8);
					min-height: 130px;

					.table-body-each-monthDate {
						width: calc(100% - 16px);
						padding: 4px 0 20px;

						.table-body-each-monthDate-day {
							font-size: 21px;
							width: 33px;
							height: 33px;
						}
					}

					.schedule-list {
						padding: 0;

						.schedule-list-each {
							margin: 5px 0 0;

							.schedule-each-info {
								border-radius: 8px 0 0 8px;

								span:last-child {
									margin: 0;
								}
							}

							.schedule-each-title {
								padding: 9px 14px;
								border-radius: 0 8px 8px 0;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>